/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * fleetster
 * OpenAPI spec version: 1.0.0
 */

export type SessionResponseDtoFrontendUserState = typeof SessionResponseDtoFrontendUserState[keyof typeof SessionResponseDtoFrontendUserState];


export const SessionResponseDtoFrontendUserState = {
  unauthorized: 'Unauthorized',
  deactivated: 'Deactivated',
  'new-without-tenants': 'NewWithoutTenants',
  'onboarding-needed': 'OnboardingNeeded',
  'no-available-tenants': 'NoAvailableTenants',
  'tenant-selection-needed': 'TenantSelectionNeeded',
  'tenant-activation-pending': 'TenantActivationPending',
  active: 'Active',
} as const;
